export default __webpack_public_path__ + "static/media/manageHoliday.154c1df0.png";